export default {
    canned_commands_tab_title: "Comandos",
    canned_commands_tab_label: "Etiqueta",
    canned_commands_tab_command: "Comando",
    canned_commands_tab_via: "Vía",
    canned_commands_tab_status: "Estado",
    canned_commands_tab_unit_type: "Tipo de Unidad",
    canned_commands_tab_created_on: "Creación",
    canned_commands_tab_created_by: "Creado por",
    canned_commands_tab_updated_on: "Actualización",
    canned_commands_tab_updated_by: "actualizado por",
    canned_commands_tab_add_new: "Agregar Nuevo",
    canned_commands_tab_apply_to_all: "Aplica a Todos los Tipos"
}